import vxRouter from './vx-router.js'
import VxRouterView from './vx-router-view.vue'

Vue.component('vx-router-view', VxRouterView)


export default vxRouter